import { AxiosResponse } from 'axios';
import axios from '../axios';
import { API_ROUTES } from '../../constants/app';
import { GuideType } from '../../types';

export async function sendView(
  name: string,
  guideId: string,
  guideTitle: string,
  chapterId: string,
  chapterTitle: string,
  pageId: string,
  pageTitle: string,
  isPublic: boolean,
  guide_type: GuideType,
  isNewService?: boolean,
): Promise<AxiosResponse> {
  return (await axios()).post(API_ROUTES.ANALYTICS(isPublic, isNewService), {
    event: {
      name,
      properties: {
        viewOrigin: isPublic ? 'public' : 'internal',
        guide: {
          id: guideId,
          title: guideTitle,
          guide_type: guide_type,
        },
        chapter: {
          id: chapterId,
          title: chapterTitle,
        },
        page: {
          id: pageId,
          title: pageTitle,
        },
      },
    },
    user: {
      agent: {
        reference: {
          url: window.location.href,
          path: window.location.pathname,
          referrer: document.referrer,
        },
      },
    },
  });
}
